/**
 * Acquire an access token for the SILISENSE API from the current Microsoft session.
 * Independent of the email/password JWT, which otherwise takes precedence in the API client.
 */
import { apiRequest, msalInstance } from '@/auth/config';

export async function acquireMicrosoftAccessToken(): Promise<string> {
  const account = msalInstance.getAllAccounts()[0];
  if (!account) throw new Error('Sign in with Microsoft before linking an account.');
  try {
    const silent = await msalInstance.acquireTokenSilent({ ...apiRequest, account });
    if (silent.accessToken) return silent.accessToken;
  } catch {
    /* fall through to an interactive prompt */
  }
  const interactive = await msalInstance.acquireTokenPopup({ ...apiRequest, account });
  if (!interactive.accessToken) throw new Error('Microsoft did not return an access token.');
  return interactive.accessToken;
}
